// extracted by mini-css-extract-plugin
module.exports = {"root":"gallerySection_root__3Iv3U","wrapper":"gallerySection_wrapper__6agaZ","info":"gallerySection_info__1LGyq","notification":"gallerySection_notification__3cSsZ"};